import React from 'react'
import { ARTICLE_STATUS_ARRAY } from '../constants/'

export const ArticleStatus = (props) => {
    let { status_id = '00000000', setArticleStatus } = props
    if (status_id === 'r') {
        status_id = '11111111'
    } else if (!status_id || status_id?.length !== 8) {
        status_id = '00000000'
    }

    return (
        <div className="d-flex justify-content-between w-100">
            {Array(8)
                .fill(null)
                .map((_, index) => (
                    <React.Fragment key={index}>
                        <RoundedIcon
                            className={(setArticleStatus ? 'pointer ' : 'cursor-default ') + (status_id[index] === '1' ? 'btn-success' : 'btn-danger')}
                            label={ARTICLE_STATUS_ARRAY[index]?.label}
                            onClick={() => {
                                console.log(
                                    { status_id },
                                    { index },
                                    status_id.substring(0, index),
                                    status_id[index] === '1' ? '0' : '1',
                                    status_id.substring(index + 1)
                                )
                                setArticleStatus?.(status_id.substring(0, index) + (status_id[index] === '1' ? '0' : '1') + status_id.substring(index + 1))
                            }}
                        >
                            <i className={'text-white ' + ARTICLE_STATUS_ARRAY[index]?.icon} />
                        </RoundedIcon>
                    </React.Fragment>
                ))}
        </div>
    )
}
export const RoundedIcon = (props) => (
    <button
        title={props.label}
        {...props}
        className={'rounded-icon btn ' + (props.className || '')}
        onClick={(e) => {
            e.preventDefault()
            props.onClick?.(e)
        }}
    >
        {props.children}
    </button>
)

export default ArticleStatus
